import React from "react";
import { ArrowLeft, FileText } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function TermsAndConditionsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FFF8EF] p-4 flex justify-center pt-20">
      {/* MAIN CARD */}
      <div className="w-full max-w-4xl bg-white rounded-3xl shadow-xl border">
        {/* BACK BUTTON */}
        <div className="flex items-start p-6 pb-2">
          <button
            onClick={() => navigate(-1)}
            className="
              w-14 h-12 bg-white rounded-2xl 
              shadow-[0_4px_12px_rgba(0,0,0,0.1)] 
              flex items-center justify-center 
              border border-gray-100
              hover:shadow-[0_6px_16px_rgba(0,0,0,0.15)]
              transition-all
            "
          >
            <div className="flex items-center gap-2">
              <ArrowLeft size={22} className="text-orange-500" />
            </div>
          </button>
        </div>

        {/* CONTENT */}
        <div className="px-8 md:px-12 pb-10">
          {/* ICON */}
          <div className="flex justify-center mb-4 mt-2">
            <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center shadow-lg">
              <FileText size={32} className="text-white" />
            </div>
          </div>

          <h1 className="text-center text-3xl font-serif font-bold">
            Terms & Conditions
          </h1>
          <p className="text-center text-gray-600 mt-2">
            Last updated: November 2025
          </p>

          <div className="mt-8 space-y-8 text-gray-800 leading-relaxed">
            <section>
              <h2 className="font-bold text-lg text-orange-700 mb-2">
                1. Acceptance of Terms
              </h2>
              <p>
                By using the Purohit App, you agree to all terms listed below.
              </p>
            </section>

            <section>
              <h2 className="font-bold text-lg text-orange-700 mb-2">
                2. User Responsibilities
              </h2>
              <ul className="list-disc ml-6 space-y-1">
                <li>Provide accurate information</li>
                <li>Keep your login credentials private</li>
                <li>Be respectful to purohits and users</li>
              </ul>
            </section>

            <section>
              <h2 className="font-bold text-lg text-orange-700 mb-2">
                3. Services
              </h2>
              <p>
                We enable users to book verified purohits. We are not
                responsible for individual service outcomes.
              </p>
            </section>

            <section>
              <h2 className="font-bold text-lg text-orange-700 mb-2">
                4. Payments & Refunds
              </h2>
              <ul className="list-disc ml-6 space-y-1">
                <li>All payments are secure</li>
                <li>Refunds follow cancellation rules</li>
                <li>Platform fee is 10%</li>
              </ul>
            </section>

            <section>
              <h2 className="font-bold text-lg text-orange-700 mb-2">
                5. Liability
              </h2>
              <p>
                Purohit App is not liable for any indirect or incidental
                damages.
              </p>
            </section>
          </div>

          {/* BUTTON */}
          <div className="mt-10 flex justify-center">
            <button
              onClick={() => navigate(-1)}
              className="
                bg-gradient-to-r from-orange-500 to-red-500 
                text-white font-semibold px-6 py-2 rounded-xl shadow-md
              "
            >
              I Understand
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
